import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { AppUser } from './types'

export const ALL_USERS_QUERY: TypedDocumentNode<
  { allUsers: AppUser[] },
  { search?: string; limit?: number; offset?: number }
> = gql`
  query AllUsers($search: String, $limit: Int, $offset: Int) {
    allUsers(search: $search, limit: $limit, offset: $offset) {
      id username email features observations created_at
    }
  }
`

export const ALL_USERS_COUNT_QUERY: TypedDocumentNode<
  { allUsersCount: number },
  { search?: string }
> = gql`
  query AllUsersCount($search: String) {
    allUsersCount(search: $search)
  }
`

export const APP_USERS_QUERY: TypedDocumentNode<
  { appUsers: AppUser[] },
  { applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query AppUsers($applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    appUsers(applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id username email features observations created_at
    }
  }
`

// The user form reads its record from the cache the user lists filled; there is no single-user
// query, so the API exposes no new way to read a user.
export const USER_FORM_FRAGMENT: TypedDocumentNode<AppUser> = gql`
  fragment UserFormFields on User {
    id username email features observations created_at
  }
`
